import React from 'react';
import TaxHero from '../../components/TaxHero/TaxHero';
import Expect from '../../components/Expect/Expect';
import Specialist from '../../components/Specialist/Specialist';
import WeOffer from '../../components/WeOffer/WeOffer';
import Testimonials from '../../components/Testimonials/Testimonials';
import Questions from '../../components/Questions/Questions';
import HomeContact from '../../components/HomeContact/HomeContact';
import { Helmet } from 'react-helmet-async';

const TaxReturn = () => {

    return (
        <>
            <Helmet>
                {/* Title */}
                <title>Individual Tax Return Services | PFGS Australia</title>

                {/* Meta Description */}
                <meta
                    name="description"
                    content="Simplify your tax return with PFGS. Our experts help Australians maximise refunds and ensure accurate, stress-free individual tax lodgements."
                />

                {/* Canonical URL */}
                <link rel="canonical" href="https://pfgs.com.au/tax-return" />

                {/* Meta Robots */}
                <meta
                    name="robots"
                    content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
                />

                {/* Open Graph (Facebook / LinkedIn / WhatsApp) */}
                <meta property="og:title" content="Individual Tax Return Services | PFGS Australia" />
                <meta property="og:description" content="Simplify your tax return with PFGS. Our experts help Australians maximise refunds and ensure accurate, stress-free individual tax lodgements." />
                <meta property="og:url" content="https://pfgs.com.au/tax-return" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://pfgs.com.au/pfgs-preview.jpg" />

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Individual Tax Return Services | PFGS Australia" />
                <meta name="twitter:description" content="Simplify your tax return with PFGS. Our experts help Australians maximise refunds and ensure accurate, stress-free individual tax lodgements." />
                <meta name="twitter:image" content="https://pfgs.com.au/pfgs-preview.jpg" />
            </Helmet>
            <div className="home-page">
                <TaxHero />
                <WeOffer />
                <Expect />
                <Specialist />
                <Testimonials />
                <HomeContact />
                <Questions />
            </div>
        </>
    );
};

export default TaxReturn;
